import Link from '@components/ui/Link'
import { ReactComponent as SpokeLogoIcon } from '@svgs/logo/spoke-logo-with-border.svg'
import { ReactComponent as TickIcon } from '@svgs/chalk/tick.svg'
import { ReactComponent as CrossIcon } from '@svgs/chalk/cross.svg'
import styles from './styles.module.scss'
import { File } from 'types/contentful/graphQlApi'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'

type ImageCard = {
  title: string
  file: File
}

export type ComparisonCardProps = {
  title: string
  showIcon: boolean | null
  imageDesktop: ImageCard
  imageMobile: ImageCard
  backgroundColor: string | null
  themeColor: 'dark-theme' | 'light-theme'
  isBrandedCard: boolean
  benefit1: string
  benefit2: string
  benefit3: string
  button: {
    uri: string
    text: string
  }
}

export default function ComparisonCard({
  title,
  imageDesktop,
  imageMobile,
  themeColor = 'dark-theme',
  button,
  benefit1,
  benefit2,
  benefit3,
  isBrandedCard,
  showIcon
}: ComparisonCardProps) {
  const Icon = isBrandedCard ? TickIcon : CrossIcon
  const isTabletUp = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.TABLET,
    initialState: false
  })

  return (
    <article className={`${styles.ComparisonCard} ${styles[themeColor]}`}>
      <div className={styles.ComparisonCard__image}>
        <picture>
          <source media="(min-width: 601px)" srcSet={imageDesktop.file.url} />
          <img alt={title} src={imageMobile.file.url} />
        </picture>
      </div>
      <div className={styles.ComparisonCard__content}>
        <div
          className={`${styles.ComparisonCard__title} ${
            !isBrandedCard ? styles.ComparisonCard__title_nonBranded : ''
          }`}
        >
          {showIcon ? (
            <SpokeLogoIcon width={62} height={51} />
          ) : (
            <h3>{title}</h3>
          )}
        </div>

        <ul>
          <li>
            <Icon width={24} height={24} />
            {benefit1}
          </li>
          <li>
            <Icon width={24} height={24} />
            {benefit2}
          </li>
          <li>
            <Icon width={24} height={24} />
            {benefit3}
          </li>
        </ul>
        {button.uri && (
          <Link
            variant="primary"
            classes={`${styles.ComparisonCard__contentButton} ${
              isTabletUp ? styles[themeColor] : ''
            }`}
            href={button.uri}
          >
            {button.text}
          </Link>
        )}
      </div>
    </article>
  )
}
